const locationsState = {
    loading: false,
    error: false,
    data: [],
    userData: {}
}
const locationsReducer = (state = locationsState, action) => {
    switch (action.type) {
        case 'REQUEST_LOCATIONS':
            return Object.assign({}, state, {
                loading: true,
                error: false
            })

        case 'REQUEST_LOCATIONS_SUCCESS':
            return Object.assign({}, state, {
                data: action.payload,
                error: false,
                loading: false
            })

        case 'REQUEST_LOCATIONS_SUCCESS_USER':
            return Object.assign({}, state, {
                userData: {
                    ...state.userData,
                    [action.privateLink]: action.payload
                },
                error: false,
                loading: false
            })

        case 'REQUEST_LOCATIONS_FAIL':
            return Object.assign({}, state, {
                loading: false,
                error: true
            })

        case 'UPDATE_LOCATION': {
            const index = state.data.findIndex(location => location.app_id === action.payload.app_id)
            let locations = state.data.slice()
            locations[index] = action.payload
            return Object.assign({}, state, {
                data: locations
            })
        }

        default:
            return state
    }
}

export default locationsReducer


// WEBPACK FOOTER //
// ./src/reducers/locationsReducer.js